import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { DataTableCellProps, TableCell } from 'components/dataTable';
import { CopyMenuItem, MenuItem } from 'components/dataTable/cells';
import { ActionMenu } from 'components/dataTable/cells/actionMenu';

import RoutePath from 'router/path';

import { LABELS } from '../../keys';
import { PayoutDataRow } from '../../types';

export const ActionsCell = ({ row }: DataTableCellProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { uuid, merchantUuid } = row as PayoutDataRow;

  const navigateToPayout = (payoutUuid: string) => () => navigate(RoutePath.pwc.payoutById(merchantUuid, payoutUuid));

  return (
    <TableCell>
      <ActionMenu title={t(LABELS.ACTIONS.TITLE)}>
        <CopyMenuItem value={uuid}>{t(LABELS.ACTIONS.COPY_PAYOUT_ID)}</CopyMenuItem>
        <MenuItem onClick={navigateToPayout(uuid)}>{t(LABELS.ACTIONS.OPEN_DETAILS)}</MenuItem>
      </ActionMenu>
    </TableCell>
  );
};
